<div class="container container-shadow pt-4 pb-5 my-4 mb-4">
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label for="name">Name</label>
        <input type="text" class="form-control" id="name" [(ngModel)]="name" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }" />
      </div>
      <div class="form-group">
        <label for="footer-html">Footer - HTML (paste HTML of footer here)</label>
        <textarea class="form-control" id="footer-html" rows="3" [(ngModel)]="htmlContent" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }"></textarea>
      </div>
      <button type="button" class="btn btn-primary" (click)="newsletterFooterId ? updateNewsletterFooter() : createNewsletterFooter()" [disabled]="isSubmitting">
        {{ isSubmitting ? 'Submitting' : 'Submit' }}<span *ngIf="isSubmitting">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span></button
      >&nbsp;<a type="button" class="btn btn-light" routerLink="/newsletter_footers" routerLinkActive="active">Cancel</a>
    </div>
  </div>
</div>
